import { render, staticRenderFns } from "./FeedbackItems.vue?vue&type=template&id=e9df7a20&"
import script from "./FeedbackItems.vue?vue&type=script&lang=js&"
export * from "./FeedbackItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports